import React from 'react';

import Tabs, { Tab } from 'common/components/Tabs';
import { rewardsOverviewRoute, rewardsHistoryRoute } from 'app/containers/routes';

const RewardsTabs = () => (
  <Tabs dataTest="rewardsTabs">
    <Tab to={rewardsOverviewRoute}>Overview</Tab>
    <Tab to={rewardsHistoryRoute}>Withdrawal history</Tab>
  </Tabs>
);

export default RewardsTabs;
